module.exports = __webpack_public_path__ + "static/media/grid-view-icon.73bec5c5.png";